/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    LearningCompetenceTypeEnum,
    LearningCompetenceTypeEnumFromJSON,
    LearningCompetenceTypeEnumFromJSONTyped,
    LearningCompetenceTypeEnumToJSON,
} from './LearningCompetenceTypeEnum';
import {
    Subject,
    SubjectFromJSON,
    SubjectFromJSONTyped,
    SubjectToJSON,
} from './Subject';

/**
 * 
 * @export
 * @interface SubjectLearningOutcome
 */
export interface SubjectLearningOutcome {
    /**
     * 
     * @type {string}
     * @memberof SubjectLearningOutcome
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof SubjectLearningOutcome
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SubjectLearningOutcome
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof SubjectLearningOutcome
     */
    subjectId?: string;
    /**
     * 
     * @type {Subject}
     * @memberof SubjectLearningOutcome
     */
    subject?: Subject;
    /**
     * 
     * @type {string}
     * @memberof SubjectLearningOutcome
     */
    description?: string | null;
    /**
     * 
     * @type {LearningCompetenceTypeEnum}
     * @memberof SubjectLearningOutcome
     */
    type?: LearningCompetenceTypeEnum;
}

export function SubjectLearningOutcomeFromJSON(json: any): SubjectLearningOutcome {
    return SubjectLearningOutcomeFromJSONTyped(json, false);
}

export function SubjectLearningOutcomeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubjectLearningOutcome {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'subjectId': !exists(json, 'subjectId') ? undefined : json['subjectId'],
        'subject': !exists(json, 'subject') ? undefined : SubjectFromJSON(json['subject']),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'type': !exists(json, 'type') ? undefined : LearningCompetenceTypeEnumFromJSON(json['type']),
    };
}

export function SubjectLearningOutcomeToJSON(value?: SubjectLearningOutcome | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'subjectId': value.subjectId,
        'subject': SubjectToJSON(value.subject),
        'description': value.description,
        'type': LearningCompetenceTypeEnumToJSON(value.type),
    };
}

